import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import { AnswersBySurveysIds } from 'src/modules/programs/surveys/models/surveys';

type ExposureAnswerToRender = Record<string, string>;

interface Props extends WithTranslation {
    answersBySurveysIds: AnswersBySurveysIds;
}

const PlannedExposuresContainer: React.SFC<Props> = ({ t, answersBySurveysIds }) => {
    const exposuresAnswersToRender: ExposureAnswerToRender[] = Object.values(
        answersBySurveysIds,
    ).map(exposure =>
        exposure.reduce(
            (acc, answer) =>
                answer.renderId
                    ? {
                          ...acc,
                          [answer.renderId]: answer.data && answer.data.content,
                      }
                    : acc,
            {},
        ),
    );

    return (
        <>
            {exposuresAnswersToRender.map((exposureAnswer: ExposureAnswerToRender) => (
                <S.PlannedActivity key={exposureAnswer['exposureTitle']}>
                    <S.ActivityName>{exposureAnswer['exposureTitle']}</S.ActivityName>
                    <S.ActivityDescription>
                        {exposureAnswer['exposureDate']},{' '}
                        {t('week-7.exposures-practice.dateDivider')}{' '}
                        {exposureAnswer['exposureTime']}
                    </S.ActivityDescription>
                </S.PlannedActivity>
            ))}
        </>
    );
};

export const PlannedExposures = withTranslation('cbt')(PlannedExposuresContainer);
